module.exports = __webpack_public_path__ + "img/robotsan.f8bce603.png";